import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '@utils/i18n';
import DayOfMonthSelector from './DayOfMonthSelector';

const namespace = 'features.invoices.recurrence_modal';

function DayOfMonthSelection({ dayOfMonthOption, dayOfMonth, onOptionChange, onDayChange }) {
  return (
    <div className="pl-4">
      <label className="qmb-radio">
        <input
          type="radio"
          name="day_of_month_option"
          value="first_day"
          checked={dayOfMonthOption === 'first_day'}
          onChange={() => onOptionChange('first_day')}
        />
        {translate('first_day_of_month', { namespace })}
      </label>
      <label className="qmb-radio">
        <input
          type="radio"
          name="day_of_month_option"
          value="last_day"
          checked={dayOfMonthOption === 'last_day'}
          onChange={() => onOptionChange('last_day')}
        />
        {translate('last_day_of_month', { namespace })}
      </label>
      <div style={{ alignItems: 'center', display: 'flex' }}>
        <label className="qmb-radio">
          <input
            type="radio"
            name="day_of_month_option"
            value="custom_day"
            checked={dayOfMonthOption === 'custom_day'}
            onChange={() => onOptionChange('custom_day')}
          />
          {translate('custom_day', { namespace })}
        </label>
        {dayOfMonthOption === 'custom_day' && (
          <DayOfMonthSelector
            value={dayOfMonth}
            onChange={onDayChange}
            disabled={dayOfMonthOption !== 'custom_day'}
          />
        )}
      </div>
    </div>
  );
}

DayOfMonthSelection.propTypes = {
  dayOfMonthOption: PropTypes.oneOf(['first_day', 'last_day', 'custom_day']).isRequired,
  dayOfMonth: PropTypes.number.isRequired,
  onOptionChange: PropTypes.func.isRequired,
  onDayChange: PropTypes.func.isRequired
};

export default DayOfMonthSelection;
